module.exports = __webpack_public_path__ + "img/ic_add_file_1.69e90cfe.svg";